<template>
    <div class="w-full max-w-4xl mx-auto flex flex-col gap-y-6 mt-8 mx-auto">
        <div class="w-full">
            <WelcomeCardWithInboxStats class="col-span-2 order-0"
                                       @toggle-stats-card="toggleStatCards()"
                                       :show-stat-cards="showStatCards"
            ></WelcomeCardWithInboxStats>
        </div>

        <!--Info Cards-->
        <transition name="slide">
            <div v-show="showStatCards">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <maintenance-requests-stat-card class="col-span-2 lg:col-span-1 order-1">
                    </maintenance-requests-stat-card>

                    <ticket-stats-card class="col-span-2 lg:col-span-1 order-2"
                                       @open-ticket-create-modal="toggleTicketCreateModal()">
                    </ticket-stats-card>

                    <inspections-stats-card class="col-span-2 lg:col-span-1 order-3">
                    </inspections-stats-card>

                    <portfolio-stats-card class="col-span-2 order-4 lg:col-span-1">
                    </portfolio-stats-card>
                </div>
            </div>
        </transition>

        <todo-list></todo-list>

        <welcome-modal v-if="state.user.settings.show_welcome_message"></welcome-modal>

        <ticket-create-modal-base
            :show="showTicketCreateModal"
            @close-modal="toggleTicketCreateModal">
        </ticket-create-modal-base>
    </div>
</template>

<script>
import WelcomeCardWithInboxStats from "./WelcomeCardWithInboxStatsCard";
import MaintenanceRequestsStatCard from "./MaintenanceRequestsStatsCard";
import TicketStatsCard from "./TicketStatsCard";
import InspectionsStatsCard from "./InspectionsStatsCard";
import PortfolioStatsCard from "./PortfolioStatsCard";

export default {
    name: "HomeDashboard",

    components: {PortfolioStatsCard, InspectionsStatsCard, TicketStatsCard, MaintenanceRequestsStatCard, WelcomeCardWithInboxStats},

    data () {
        return {
            dialogVisible: false,
            selectedTicketId: null,
            showAllTicketFollowUps: false,
            showStatCards: false,
            showTicketCreateModal: false,
        };
    },

    mounted () {
        this.showStatCards = 'show_home_stat_cards' in this.state.user.settings ? this.state.user.settings.show_home_stat_cards : true;
    },

    methods: {
        goToTicket (ticketId) {
            window.open("/tickets/" + ticketId);
        },

        toggleStatCards () {
            this.showStatCards = !this.showStatCards;
            App.post("/home/toggle-stat-cards", new AppForm({
                show: this.showStatCards
            }));
        },

        toggleTicketCreateModal () {
            this.showTicketCreateModal = !this.showTicketCreateModal;
        },
    },
};
</script>
